/**
 * Welche Aufgabe gerade im Aufgaben-Dialog offen ist.
 *
 * Ein einziger Dialog fuer die ganze App (`TaskDialogHost` in der Huelle):
 * jede Aufgabenzeile, egal in welcher Ansicht, oeffnet ihn mit einem Klick
 * auf den Titel. So muss keine Ansicht eigenen Dialogzustand mitschleppen.
 */
import { create } from 'zustand';

import type { ID } from '@/domain/types';

interface TaskDialogState {
  taskId: ID | null;
  open: (taskId: ID) => void;
  close: () => void;
}

export const useTaskDialog = create<TaskDialogState>()((set) => ({
  taskId: null,
  open: (taskId) => set({ taskId }),
  close: () => set({ taskId: null }),
}));
